(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    (() => {
    // Reveal the "Cookie settings" item once Shopify's cookie banner API is
    // available, and reopen the banner's preferences on click. The banner script
    // loads asynchronously, so poll briefly; if it never appears (banner off),
    // the item stays hidden.
    const items = () => document.querySelectorAll('[data-cookie-settings]');
    if (!items().length) return;

    const api = () => window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';

    const reveal = () => {
      items().forEach((item) => {
        item.hidden = false;
        const button = item.querySelector('button');
        if (button && !button.dataset.bound) {
          button.dataset.bound = 'true';
          button.addEventListener('click', () => window.privacyBanner.showPreferences());
        }
      });
    };

    let tries = 0;
    const wait = () => {
      if (api()) return reveal();
      if (++tries < 40) setTimeout(wait, 250);
    };
    wait();
  })();
  } catch(e) { console.error(e); }
})();

})();
